export default "/_next/static/images/torn-bottom-3-93f8ce02e6a377dca22f3547c384daf8.svg";